// extracted by mini-css-extract-plugin
export default {"tsection":"Testimonial_tsection__gPHfi","tsectionh4":"Testimonial_tsectionh4__xiqOF","tsectionh1":"Testimonial_tsectionh1__LW9hc","tsectionh2":"Testimonial_tsectionh2__gJ65c"};